export default __webpack_public_path__ + "static/media/booklist.0a286906.png";